import * as React from 'react';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { browserHistory } from 'react-router';
import { cookies } from 'helpers/cookies';
const config = require('../../../../../config/main');
require('./style.scss');

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class LandingPageJoinPopup extends React.Component<any, any> {
	constructor(props) {
		super(props);
	}

	public render() {
		const { t } = this.props;
		return (
			<div className="popup-landing-join">
				<div className="background-box">
					<img
						className="rotated-image desktop"
						src={require('../../Html/images/landing-page-popup-img.png')}
						alt="Rotated"
					/>
					<img
						className="rotated-image mobile"
						src={require('../../Html/images/landing-page-popup-img-mobile.png')}
						alt="Rotated"
					/>
					<img
						className="cikcak mobile"
						src={require('../../Html/images/cikcak-landing-page-popup.png')}
						alt="Background"
					/>
					<div className="content-wrapper">
						<div className="text-block">
							<div className="text-group">
								<div className="text-group">
									<div className="badge">
										<div className="badge-text">{t('LandingPage_Popup_one_month_free')}</div>
									</div>
								</div>
								<div className="large-text">
									<span className="underlined">{t('LandingPage_Popup_ownSalon_underline')}</span>
									<span> {t('LandingPage_Popup_ownSalon_normal')} </span>
									<span className="bold"> {t('LandingPage_Popup_ownSalon_bold')} </span>
									<span> {t('LandingPage_Popup_ownSalon_normal_1')} </span>
									<span className="bold">{t('LandingPage_Popup_ownSalon_bold_1')}</span>
								</div>
							</div>
							<div className="description-text">
								<span>{t('LandingPage_Popup_description')} </span>
								<span className="underlined">{t('LandingPage_Popup_description_underline')}</span>
								<span className="bold"> </span>
								<span className="italic">{t('LandingPage_Popup_description_1')}</span>
								<span> </span>
								<span className="highlight">{t('LandingPage_Popup_description_bold')}</span>
								<span>. </span>
								<span>{t('LandingPage_Popup_description_2')}</span>
							</div>
						</div>
						<div className="button openNewshop" onClick={this.openNewShop}>
							<div className="button-text">{t('LandingPage_Popup_btn')}</div>
						</div>
						<div className="close-icon-wrapper" onClick={this.closePopup}>
							<img className="close-icon desktop" src={require('../../Html/icons/close_silver.svg')} alt="Close" />
							<img className="close-icon mobile" src={require('../../Html/icons/close_black.svg')} alt="Close" />
						</div>
					</div>
				</div>
			</div>
		);
	}

	private closePopup = () => {
		// Call the function passed from the parent component
		if (typeof this.props.closePopup === 'function') {
			cookies.set(c.COOKIE_KEY_LANDING_PAGE_POPUP, true, { path: '/', domain: config.app.authSettings.domain });
			this.props.closePopup();
		}
	};
	private openNewShop() {
		browserHistory.push('/shop');
	}
}

export default LandingPageJoinPopup;
